import React, { useEffect, useState } from 'react';

import * as yup from 'yup';
import { Formik } from 'formik';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { push } from 'react-router-redux';
import { Button, Input } from 'shared/lib/SureDesignSystem/';
import withGlobals from '../../withGlobals';
import Axios from 'axios';
import { magicLinkSignIn } from '../../store/actions';
import AuthLayout from '../AuthLayout/AuthLayout';

import styles from './Login.module.css';

const validationSchema = yup.object({
  email: yup
    .string()
    .email('Must be a valid email')
    .required('Email is required'),
});

const initialValues = {
  email: '',
};

const headers = {
  'X-Space': 'sure',
};

const axiosOverride = Axios.create();
axiosOverride.defaults.headers.common = headers;
axiosOverride.defaults.headers.common.accept = 'application/json';
axiosOverride.defaults.baseURL = process.env.REACT_APP_API_V2;
const endpoint = '/api/v2/clients/send-customer-login-link/';

function Login({ magicLinkSignIn, navTo, authToken }) {
  useEffect(() => {
    const urlToken = new URL(window.location.href).searchParams.get('token');
    if (!urlToken) {
      return;
    }

    if (!authToken) {
      magicLinkSignIn(urlToken).then(res => {
        if (!res.auth.token) {
          return;
        }
        navTo('/account');
      });
    }
    navTo('/account');
  }, []);
  const [submitted, setSubmitted] = useState(false);

  function submitHandler({ email }, { setErrors, setSubmitting }) {
    axiosOverride
      .post(endpoint, {
        email,
      })
      .then(() => {
        setSubmitted(true);
      })
      .catch(err => {
        const { detail } = err.response.data;
        if (detail) {
          if (detail.includes('Client matching')) {
            setErrors({
              email:
                'We are unable to send you a login link at this time. If you are trying to access your policy documentation, update your billing information, or make changes to your coverage, please contact our support team at support@sureapp.com and we would be happy to assist!',
            });
          } else {
            setErrors({
              email: detail,
            });
          }
          setSubmitting(false);
        } else {
          setErrors({
            email: 'There was an error with your submission',
          });
          setSubmitting(false);
        }
      });
  }

  return (
    <AuthLayout
      title="Sign In"
      description="Enter the email address associated with your account and we'll send you a link for a password-free sign in."
    >
      <Formik
        validationSchema={validationSchema}
        initialValues={initialValues}
        onSubmit={submitHandler}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          errors,
          touched,
          isSubmitting,
        }) =>
          submitted ? (
            <>
              <hr className={styles.heroSection_divider} />
              <h4 className={styles.heroSection_subtitle}>
                Thanks! Please check your email for a special link to log into
                your account dashboard. Your sign-in link will expire after 24
                hours and can only be used once.
              </h4>
              <div>
                <h4 className={styles.heroSection_subtitle}>
                  We sent your link to:
                </h4>
                <h4 className={styles.heroSection_subtitle}>
                  <b>{values.email}</b>
                </h4>
              </div>
            </>
          ) : (
            <form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <Input
                label="Email Address"
                placeholder="you@example.com"
                name="email"
                id="email"
                value={values.email}
                error={errors.email}
                touched={touched.email}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <Button
                style={{ width: '100%' }}
                type="submit"
                disabled={isSubmitting || errors.email}
              >
                Send Email
              </Button>
            </form>
          )
        }
      </Formik>
    </AuthLayout>
  );
}
const mapStateToProps = state => {
  return {
    isAuthInProgress: state.isAuthInProgress,
    authToken: state.authToken,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        magicLinkSignIn,
      },
      dispatch
    ),
    navTo: route => dispatch(push(route)),
  };
};

const enhance = compose(
  withRouter,
  withGlobals(),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
);

export default enhance(Login);
